module.exports = __webpack_public_path__ + "img/chevron-down.60e2c9d3.svg";